import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import SuspendCard from './suspendcard.jsx'



class BlockCards extends Component {
    render() {
        return (
            <div>
                <div className="row" >
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>
                    <div className="container" style={{ marginTop: "80px" }}>
                        <div className="row">
                            <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                <LeftLink />
                            </div>

                             <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "12px 10px", minHeight: "476px" }}>
                                <h2>Block/Unblock Card</h2>
                                <SuspendCard />
                            </div>
                        </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BlockCards;




// WEBPACK FOOTER //
// ./src/components/additionalservices/blockcards.jsx